/**
 * Tablet-only drawer host that renders the same filters sidebar chrome as desktop (empty filter body, disabled actions).
 */
import { Drawer } from "../../../../../components/drawer/drawer";
import RmaListFiltersSidebar from "../rma-list-filters-sidebar/rma-list-filters-sidebar";
import "./rma-list-filters-tablet-drawer.scss";

interface IProps {
    onClose: () => void;
}

const RmaListFiltersTabletDrawer: React.FC<IProps> = ({ onClose }) => {
    return (
        <Drawer closeButton={{ onClick: onClose }}>
            <div className="rma-list-filters-tablet-drawer">
                <RmaListFiltersSidebar />
            </div>
        </Drawer>
    );
};

export default RmaListFiltersTabletDrawer;
